<template>
  <span>
    <b-form-checkbox
      v-b-tooltip.hover="`${active? 'Desactivar': 'Activar'} notificación`"
      switch
      :checked="active"
      @input="active = $event; $emit('add-active', $event)"
    >
      <span class="switch-icon-left">
        <feather-icon icon="BellIcon" />
      </span>
      <span class="switch-icon-right">
        <feather-icon icon="BellOffIcon" />
      </span>
    </b-form-checkbox>
  </span>
</template>

<script>
import {
  BFormCheckbox,
  VBTooltip,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BFormCheckbox,
  },
  setup(_, { emit }) {
    const active = ref(true)
    onMounted(() => emit('add-active', active.value))

    const resetComponent = () => { active.value = true }
    return { active, resetComponent }
  },
}
</script>
